import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();
export function Toast(type, desc) {
  toast(desc, {
    type: type,
  });
}
